export interface IFlagAction<Flag> {
    flag: Flag;
    value: boolean;
}

export interface IFlaggedState<Flag> {
    flags: Flag[];
    nightingalesFlags: Flag[];
    flagsV3: Flag[];
  }

export const flagsState = {flags: [], nightingalesFlags: [], flagsV3:[]};

export function handleFlagChange<Flag>(flags: Flag[], action: IFlagAction<Flag>) {
    const mFlags = flags.slice();
    const flagIndex = mFlags.indexOf(action.flag);
    if (!action.value && flagIndex !== -1) {
        mFlags.splice(flagIndex, 1);
    } else if (action.value && flagIndex === -1) {
        mFlags.push(action.flag);
    }
    return {flags: mFlags};
}

export function handleSingleFlagChange<Flag>(flags: Flag[], action: IFlagAction<Flag>) {
    const mFlags = [];
    if (action.value) {
        mFlags.push(action.flag);
    }
    return mFlags;
}

export function flagged<Flag>(flags: Flag[], flag: Flag) {
    return flags.indexOf(flag) !== -1;
}
